export default "__VITE_ASSET__CPW32wbK__"